<template>
	<div>
		<div class="detail-bg">
			<van-row class="video-play-area">
				<van-col span="24">
					<div id="player" class="video-play-bg" :class="{'hide': hasVideo == false}"></div>
					<van-image class="course-banner" :class="{'show': hasVideo == false}" fit="cover" :src="imgUrl + videoInfo.video_banner_image" />
				</van-col>
			</van-row>
			<van-row class="list-bg">
				<van-col span="24">
					<van-cell class="detail-list" title="目录" is-link :value="videoListCount" />
					<div class="list-container">
						<div class="fix list-item" :class="{'list-item-title-on': current == index}" v-for="(item, index) in videoInfo.subsection"
						 :key="index" @click="playVideo(item.polyv_vid),playStyle(index)">
							<div class="fl list-item-imgbox">
								<van-image class="list-item-img" fit="cover" :src="item.polyv_first_image" />
							</div>
							<div class="fl list-item-title">{{item.subsection_title}}</div>
						</div>
					</div>
				</van-col>
			</van-row>
			<van-row class="list-bg list-bg-margin lecturer-container-pad-b">
				<van-col span="24">
					<van-cell class="detail-list" title="讲师" />
					<van-col span="24" class="lectinfo-container" v-if="lecturer.length == 1" v-for="(item, index) in lecturer" :key="index">
						<van-col span="24" class="lectinfo-personalinfo">
							<van-image class="lectinfo-tx" fit="cover" :src="imgUrl+item.lecturer_image" />
							<div class="lectinfo-personalinfo-r">
								<div class="lectinfo-name">{{item.lecturer_name}}</div>
								<div class="lectinfo-title">{{item.lecturer_title}}</div>
							</div>
						</van-col>
						<!-- <van-col span="24" class="lectinfo-intro">{{videoInfo.lecturer_synopsis}}</van-col> -->
					</van-col>
					<!-- 多个讲师 10.8 -->
					<div class="lectinfo-container-more" v-if="lecturer.length > 1">
						<div class="lectinfo-container-more-item" v-for="(item, index) in lecturer" :key="index">
							<van-image class="lectinfo-tx" fit="cover" :src="imgUrl+item.lecturer_image" />
							<div class="lectinfo-personalinfo-r">
								<div class="lectinfo-name">{{item.lecturer_name}}</div>
								<div class="lectinfo-title">{{item.lecturer_title}}</div>
							</div>
						</div>
					</div>
				</van-col>
			</van-row>
			<van-row class="list-bg list-bg-margin">
				<van-col span="24">
					<van-cell class="detail-list" title="课程简介" />
					<van-col span="24" class="detail-course-intro">
						<div ref="videoIntro" v-html='videoInfo.video_content'></div>
					</van-col>
				</van-col>
			</van-row>
		</div>
		<van-image class="toIndex" fit="cover" src="../../../static/images/toindex.png" @click='toIndex' />
	</div>
</template>

<script>
	import wxapi from '@/common/wxapi.js'
	export default {
		data() {
			return {
				imgUrl: 'http://sls.zhishen.net.cn', //图片拼接路径
				videoInfo: '',
				lecturer: [],
				videoListCount: '',
				polyvVid: '',
				hasVideo: '',
				videoTitile: '',
				videoImgurl: '',
				videoDesc: '',
				current: 0
			}
		},
		created() {
			let that = this;
			//授权登录
			if (localStorage.getItem('userId') == null) {
				localStorage.setItem('beforeUrl', location.href.split('&')[0])
				that.$router.push({
					path: '/author'
				})
			}
			// 百度统计
			let _hmt = _hmt || [];
			(function() {
				//每次执行前，先移除上次插入的代码
				document.getElementById('baidu_tj') && document.getElementById('baidu_tj').remove();
				let hm = document.createElement("script");
				hm.src = "https://hm.baidu.com/hm.js?5bf14d717bf0afb01060aea203da42c2";
				hm.id = "baidu_tj";
				let s = document.getElementsByTagName("script")[0];
				s.parentNode.insertBefore(hm, s);
			})();
			let formdata = new FormData();
			formdata.append('token', localStorage.getItem('token'));
			formdata.append('video_id', location.href.split('&')[0].split('?')[1].split('=')[1]);
// 			formdata.append('token', 'dd7aa8f4-2714-442d-8e30-2282e3664d10');
// 			formdata.append('video_id', 2);
			that.$axios.post('http://sls.zhishen.net.cn/api/video/getVideoDetails', formdata)
				.then(function(res) {
					that.videoInfo = res.data.video_info
					that.videoTitile = res.data.video_info.video_title
					that.videoImgurl = that.imgUrl + res.data.video_info.video_thumbnail_image
					that.videoDesc = res.data.video_info.video_synopsis
					that.lecturer = res.data.lecturer
					setTimeout(function() {
						document.title = that.videoTitile
					}, 100)
					if (res.data.video_info.subsection == null) {
						that.videoListCount = '共0节';
						that.hasVideo = false
					} else {
						that.hasVideo = true
						that.polyvVid = res.data.video_info.subsection[0].polyv_vid
						that.videoListCount = '共' + res.data.video_info.subsection.length + '节'

						let formdata11 = new FormData();
						formdata.append('polyv_vid', that.polyvVid);

						that.$axios.post('http://sls.zhishen.net.cn/api/video/getPlayToken', formdata)
							.then(function(res) {


								that.player = polyvObject('#player').videoPlayer({
									'width': '100vw',
									'height': '56.27vw',
									'vid': that.polyvVid,
									ts: res.data.ts,
									sign: res.data.sign,

								});
							})
							.catch(function(error) {

								console.log(error);
							});
						let interval = setInterval(that.render, 500);
					}
					// 分享去除微信默认参数
					if (/from=[^&$?]{1,}(&|$)/.test(location.search) || /isappinstalled=[^&$?]{1,}(&|$)/.test(location.search)) {
						let newSearch = location.search.replace(/from=[^&$?]{1,}(&|$)/, '').replace(/isappinstalled=[^&$?]{1,}(&|$)/, '')
							.replace(/&$|\?$/, '');
						let newUrl = location.origin + location.pathname + newSearch + location.hash;
						location.replace(newUrl);
						let option = {
							title: that.videoTitile,
							link: newUrl,
							imgUrl: that.videoImgurl,
							desc: that.videoDesc
						}
						wxapi.wxRegister(option)
					} else {
						let option = {
							title: that.videoTitile,
							link: location.href.split('&')[0],
							imgUrl: that.videoImgurl,
							desc: that.videoDesc
						}
						wxapi.wxRegister(option)
					}
				})
				.catch(function(error) {
					console.log(error);
				});
		},
		methods: {
			//点击目录播放视频
			playVideo(vid) {
				let that = this
				that.polyv_vid = vid;

				let formdata = new FormData();
				formdata.append('polyv_vid', vid);

				that.$axios.post('http://sls.zhishen.net.cn/api/video/getPlayToken', formdata)
					.then(function(res) {

						that.player.changeVid({
							vid: vid,
							autoplay: true,
							ts: res.data.ts,
							sign: res.data.sign,
						})
					})
					.catch(function(error) {

						console.log(error);
					});

				let interval = setInterval(that.render, 500);
			},
			//点击视频添加高亮
			playStyle(index) {
				this.current = index;
			},
			//回首页
			toIndex() {
				this.$router.push({
					path: '/'
				});
			}
		}
	}
</script>

<style>
	@import url("../../assets/css/detail.css");
</style>



// WEBPACK FOOTER //
// src/view/video/detail.vue